/**
 * HTML Video
 * https://webkit.org/blog/7734/auto-play-policy-changes-for-macos/
 */

export default function() {
    (function($) {
        $(function() {
            const bgVideos = document.querySelectorAll(
                "video.mg-graphic-layer"
            );

            bgVideos.forEach(video => {
                const promise = video.play();

                if (promise !== undefined) {
                    promise
                        .catch(error => {
                            // Auto-play was prevented
                            // Show a UI element to let the user manually start playback
                        })
                        .then(() => {
                            // Auto-play started
                        });
                }
            });
        });
    })(jQuery);
}



// WEBPACK FOOTER //
// ./src/js/partials/video.js